import { ComponentPropsWithoutRef } from "react";
import { BlockMediaCalloutCard as IBlockMediaCalloutCard } from "~/sanity/types";
import { CardCallout, CardCalloutProps } from "../cards/CardCallout";
import * as styles from "./BlockMediaCalloutCard.css";
import { IImage, Image } from "~/components/elements/Image";
import Grid from "~/components/globals/Grid";

export type BlockMediaCalloutCardProps = ComponentPropsWithoutRef<"div"> &
  IBlockMediaCalloutCard & {
    theme?: CardCalloutProps["theme"];
    inverted?: boolean;
  };

export const BlockMediaCalloutCard = ({
  theme = "dark",
  inverted = true,
  ...props
}: BlockMediaCalloutCardProps) => {
  const { image, cardCallout } = props;

  return (
    <Grid className={styles.card}>
      {image && (
        <div className={styles.imageContainer({ inverted: inverted })}>
          <Image image={image as IImage} className={styles.image} width={780} />
        </div>
      )}
      {cardCallout && (
        <div className={styles.callout({ inverted: inverted })}>
          <CardCallout card={cardCallout} theme={theme} />
        </div>
      )}
    </Grid>
  );
};
